import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const FellowsImplementingSkillsFromOnlineTraining = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Fellows implementing skills from online training (%)" />
    </Box>
  );
};
